/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useCallback,
  useEffect,
  useState,
  useMemo,
 
} from "react";

import Card from "components/card";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
import { format } from "date-fns";
import { useGlobalContext } from "context/globalContext";
import EditOrDeleteTemplate from "../edit-del-template/editAndDeleteTemplate";
import { getTemplateAPI, getFilterMessage } from "Api/templateAPI";
import Loader from "components/loader/Loader";
import CreateTemplate from "../create-template/createTemplate";
import { consoleLog } from "helpers";

const TemplateTable = () => {
  const { fetchMessage, setFetchMessage } = useGlobalContext();
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterTableData, setFilterTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  console.log(setSearchQuery)
  // const [totalPages, setTotalPages] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  console.log(setPageIndex)

  // const debounceRef = useRef();

  // const handleSearchQuery = useCallback((value) => {
  //   if (debounceRef.current) clearTimeout(debounceRef.current);
  //   debounceRef.current = setTimeout(() => {
  //     setSearchQuery(value);
  //     setPageIndex(0);
  //   }, 300);
  // }, []);

  const getFilterMessageData = useCallback(async () => {
    if (searchQuery === "") return;

    const token = localStorage.getItem("jwtToken");
    const limit = 10;
    const response = await getFilterMessage(
      { searchQuery, pageIndex, limit },
      setIsLoading,
      token
    );
    // consoleLog([response.totalPages, "totalPages"]);
    try {
      if (response) {
        consoleLog([response, searchQuery, "res"]);
        setFilterTableData(response.data);
        // setTotalPages(response.totalPages);
        setFetchMessage(false);
      }
    } catch (error) {
      consoleLog([error, "error"]);
    }
  }, [searchQuery, pageIndex, setFetchMessage]);

  const getTemplates = useCallback(async () => {
    const token = localStorage.getItem("jwtToken");

    const response = await getTemplateAPI(setIsLoading, token);

    if (response) {
      setTableData(response.data);
      setFetchMessage(false);
    }
  }, [setFetchMessage]);

  useEffect(() => {
    if (fetchMessage) {
      if (searchQuery === "") {
        getTemplates();
      } else {
        getFilterMessageData();
      }
      setFetchMessage(false);
    }
  }, [fetchMessage, getTemplates, getFilterMessageData, searchQuery]);

  useEffect(() => {
    if (searchQuery === "") {
      getTemplates();
    } else {
      getFilterMessageData();
    }
  }, [searchQuery, pageIndex, getTemplates, getFilterMessageData]);

  const columnsData = useMemo(
    () => [
      {
        Header: "Type",
        accessor: "type",
      },
      {
        Header: "Key",
        accessor: "key",
      },
      {
        Header: "Value",
        accessor: "value",
      },
      {
        Header: "Created At",
        accessor: "createdAt",
      },

      {
        Header: "Actions",
        accessor: "actions",
      },
    ],
    []
  );

  const columns = useMemo(() => columnsData, [columnsData]);

  const tableInstance = useTable(
    {
      columns,
      data: searchQuery === "" ? tableData : filterTableData,
      manualPagination: true,
      // pageCount: totalPages,
      pageIndex,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,

    // gotoPage,
  } = tableInstance;

  // const handlePageChange = (direction) => {
  //   if (direction === "next" && pageIndex < totalPages - 1) {
  //     setPageIndex((prevPageIndex) => {
  //       const newPageIndex = prevPageIndex + 1;
  //       gotoPage(newPageIndex);
  //       return newPageIndex;
  //     });
  //   }

  //   if (direction === "previous" && pageIndex > 0) {
  //     setPageIndex((prevPageIndex) => {
  //       const newPageIndex = prevPageIndex - 1;
  //       gotoPage(newPageIndex);
  //       return newPageIndex;
  //     });
  //   }
  // };

  return (
    <Card extra={"w-full h-full p-4 "}>
      <div className="relative flex items-center justify-between ">
        <div className="text-xl font-bold text-navy-700 dark:text-white ">
          {/* Table A */}
        </div>
        <CreateTemplate />
      </div>

      <div>
        <div className="relative flex items-center justify-between ">
          <div className="text-xl font-bold text-navy-700 dark:text-white ">
            <div className="relative w-full sm:w-64">
              {/* <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-2 text-lg text-gray-400">
                🔍
              </span> */}
              {/* <input
                type="search"
                className="w-full rounded-md border border-gray-300 py-2 pl-8 pr-2 text-sm transition-all duration-300 ease-in-out hover:border-blue-500 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 dark:!bg-gray-10 dark:text-white"
                placeholder="Search"
                onChange={(e) => {
                  e.preventDefault();
                  handleSearchQuery(e.target.value);
                }}
              /> */}
            </div>
          </div>
        </div>

        <div className="mt-4 h-full overflow-x-scroll xl:overflow-auto">
          {isLoading &&
            (searchQuery
              ? filterTableData.length === 0
              : tableData.length === 0) && (
              <div className="flex h-[400px] w-full items-center justify-center">
                <Loader />
              </div>
            )}
          {!isLoading &&
            ((searchQuery && filterTableData.length === 0) ||
              (!searchQuery && tableData.length === 0)) && (
              <span className="block w-full text-center">No data found.</span>
            )}
          {(searchQuery ? filterTableData : tableData).length > 0 && (
            <table {...getTableProps()} className="w-full">
              <thead>
                {headerGroups.map((headerGroup, index) => (
                  <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                    {headerGroup.headers.map((column, index) => {
                      if (column.Header === "Value") {
                        return (
                          <th
                            key={index}
                            className="border-b border-gray-200 pr-20 pb-[10px] text-start dark:!border-navy-700 "
                          >
                            <p className="w-72 text-xs tracking-wide text-gray-600">
                              {column.render("Header")}
                            </p>
                          </th>
                        );
                      }
                      if (column.Header === "Version") {
                        return (
                          <th
                            key={index}
                            className="w-10 border-b border-gray-200 pr-10 pb-[10px] text-start dark:!border-navy-700 "
                          >
                            <p className="w-10 text-xs tracking-wide text-gray-600">
                              {column.render("Header")}
                            </p>
                          </th>
                        );
                      }
                      if (column.Header === "Order") {
                        return (
                          <th
                            key={index}
                            className="w-10 border-b border-gray-200 pr-10 pb-[10px] text-start dark:!border-navy-700 "
                          >
                            <p className="w-10 text-xs tracking-wide text-gray-600">
                              {column.render("Header")}
                            </p>
                          </th>
                        );
                      }
                      return (
                        <th
                          key={index}
                          className="border-b border-gray-200 pr-20 pb-[10px] text-start dark:!border-navy-700 "
                        >
                          <p className="w-20 text-xs tracking-wide text-gray-600">
                            {column.render("Header")}
                          </p>
                        </th>
                      );
                    })}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row, index) => {
                  prepareRow(row);

                  return (
                    <tr {...row.getRowProps()} key={index}>
                      {row.cells.map((cell, index) => {
                        let data = cell.render("Cell");

                        if (cell.column.Header === "Status") {
                          data = (
                            <div className="flex items-center">
                              <div className={`rounded-full text-xl`}>
                                {cell.value === true ? (
                                  <MdCheckCircle className="text-green-500" />
                                ) : cell.value === false ? (
                                  <MdCancel className="text-red-500" />
                                ) : cell.value === "Error" ? (
                                  <MdOutlineError className="text-orange-500" />
                                ) : null}
                              </div>
                            </div>
                          );
                        } else if (cell.column.Header === "Value") {
                          data = (
                            <div className="scrollbar-custom mr-5 max-h-[150px] overflow-auto overflow-y-auto overflow-x-hidden pt-[4px] pb-[8px] sm:text-[14px]">
                              {cell.value}
                            </div>
                          );
                        } else if (cell.column.Header === "Created At") {
                          data = format(
                            new Date(cell?.value || null),
                            "yyyy-MM-dd HH:mm:ss"
                          );
                        } else if (cell.column.Header === "Actions") {
                          data = (
                            <EditOrDeleteTemplate
                              width="w-[68px]"
                              value={cell.value}
                              cell={cell}
                            />
                          );
                        }

                        return (
                          <td
                            className="px-[7px] pt-[14px] pb-[8px] sm:text-[14px]"
                            {...cell.getCellProps()}
                            key={index}
                          >
                            <p
                              className={`max-w-fit ${
                                cell.column.Header === "Key" && "cursor-pointer"
                              }`}
                            >
                              {data}
                            </p>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}

          {/* {((!!tableData.length && !searchQuery) ||
            (!!filterTableData.length && searchQuery)) && (
            <div className="mt-4 flex items-center justify-between">
              <button
                onClick={() => handlePageChange("previous")}
                disabled={pageIndex === 0}
                className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
                  pageIndex > 0
                    ? "bg-blue-500 hover:bg-blue-600"
                    : "cursor-not-allowed bg-gray-300"
                }`}
              >
                Previous
              </button>

              <span className="text-sm text-gray-700 dark:text-white">
                Page <strong>{pageIndex + 1}</strong> of{" "}
                <strong>{totalPages}</strong>
              </span>

              <button
                onClick={() => handlePageChange("next")}
                disabled={pageIndex >= totalPages - 1}
                className={`rounded-md px-4 py-2 text-sm font-medium text-white ${
                  pageIndex < totalPages - 1
                    ? "bg-blue-500 hover:bg-blue-600"
                    : "cursor-not-allowed bg-gray-300"
                }`}
              >
                Next
              </button>
            </div>
          )} */}
        </div>
      </div>
    </Card>
  );
};

export default TemplateTable;
